import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getLanguage } from "../../javascript/SelectLanguage";
import {
  useGetQueryResultMutation,
  useViewOrderMutation,
} from "../../services/Post";

export default function TrackOrder() {
  const userToken = useSelector((state) => state?.local?.token);
  const accountType = useSelector((state) => state?.local?.accountType);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [getQuery, { isLoading: loadersss }] = useGetQueryResultMutation();
  const [viewOrder, { isLoading }] = useViewOrderMutation();

  const [isImageProcessing, setIsImageProcessing] = useState(false);
  const [orderId, setOrderId] = useState("");

  const handleOrder = async () => {
    if (!orderId.trim()) {
      toast.error(t("Please enter an order ID"));
      return;
    }

    try {
      const res = await viewOrder({
        ids: orderId,
        userToken,
        accountType,
      });

      if (res?.data?.error || res?.error?.data?.error) {
        toast.error(res?.data?.message || res?.error?.data?.message);
      } else {
        toast.success(res?.data?.message || res?.error?.data?.message);
        const dropdownEl = document.getElementById("track-your-order");
        if (dropdownEl) {
          const dropdown = window.bootstrap.Dropdown.getInstance(dropdownEl);
          dropdown?.hide();
        }
        navigate(`/my-order-details/${orderId}`, {
          state: { orderData: res.data },
        });
      }
    } catch (error) {
      toast.error(t("Failed to track order. Please try again."));
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleOrder();
    }
  };

  return (
    <>
      <div className="dropdown ms-auto w-auto">
        <button
          className="nav-link btn btn-light rounded-pill px-3 py-1 shadow-sm"
          type="button"
          id="track-your-order"
          data-bs-toggle="dropdown"
          data-bs-auto-close="outside"
          aria-expanded="false"
        >
          <i className="fa fa-truck me-2 text-primary"></i>
          {t("Track Your Order")}
        </button>

        <div
          aria-labelledby="track-your-order"
          className="dropdown-menu track-your-order px-4 py-4 border-0 shadow-lg rounded-4"
        >
          <h6 className="fw-semibold mb-3">{t("Track Order")}</h6>

          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control rounded-start-pill"
              placeholder={t("Enter Order ID")}
              value={orderId}
              onChange={(e) => setOrderId(e.target.value)}
              onKeyPress={handleKeyPress}
            />
            <button
              className="btn btn-primary rounded-end-pill"
              onClick={() => {
                handleOrder();
                // const dropdownEl = document.getElementById("track-your-order");
                // if (dropdownEl) {
                //   const dropdown =
                //     window.bootstrap.Dropdown.getInstance(dropdownEl);
                //   dropdown?.hide();
                // }
              }}
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="spinner-border spinner-border-sm" />
              ) : (
                t("Track")
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
